import {
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  Tooltip,
} from 'chart.js';
import { memo } from 'react';
import { Bar } from 'react-chartjs-2';

import { convertStatus } from '../../../../api/enumerations';
import { WorkOrderData } from '../../../../api/workOrders/types';
import { STATUS_COLORS } from '../../../../constants/status';
import { CHART_TITLES } from '../../constants';
import { groupByStatus } from '../../utils/aggregations';
import { ChartCard } from '../ChartCard';

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  Tooltip,
  BarController
);

interface StatusFunnelProps {
  data: WorkOrderData[];
}

function StatusFunnelImpl({ data }: StatusFunnelProps): JSX.Element {
  const stats = groupByStatus(data);
  const chartData = {
    labels: stats.map((s) => convertStatus(s.status)),
    datasets: [
      {
        label: 'OS',
        data: stats.map((s) => s.count),
        backgroundColor: stats.map((s) => STATUS_COLORS[s.status]),
        borderRadius: 4,
      },
    ],
  };

  const options = {
    indexAxis: 'y' as const,
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: {
      x: { beginAtZero: true, ticks: { precision: 0 } },
    },
  };

  const total = stats.reduce((acc, s) => acc + s.count, 0);
  return (
    <ChartCard
      title={CHART_TITLES.statusFunnel}
      ariaLabel={`Distribuição por status: ${stats
        .map((s) => `${convertStatus(s.status)} ${s.count}`)
        .join(', ')}. Total ${total} OS.`}
    >
      <Bar data={chartData} options={options} />
    </ChartCard>
  );
}

export const StatusFunnel = memo(StatusFunnelImpl);
